import axios from './api'
const clienteleServer = {	
	SearchClienteleBuy(params) {
		return axios.post(`app/kkOrder/pageBought`, params).then((res) => {
            return res.data
        })
	},
	SearchClienteleQuit(params) {
		return axios.post(`app/kkOrder/pageRefund`, params).then((res) => {
            return res.data
        })
	},

	SearchClienteleInfo(params) {
		return axios.post(`app/kkOrder/detail`, params).then((res) => {
            return res.data
        })
	},
	quitClientele(params) {
		return axios.post(`app/kkOrder/refund`, params).then((res) => {
            return res.data
        })
	},

	SearchReason(params) {
		return axios.get(`app/kkOrder/refundReason`, params).then((res) => {
            return res.data
        })
	},
	SearchQuitStatus(params) {
		return axios.get(`app/kkOrder/canRefund`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},

	quitCreate(params) {
		return axios.post(`app/kkOrder/newRefund`, params).then((res) => {
            return res.data
        })
	},
	Upload(params) {
		return axios.post(`admin/file/upload`, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {
			return res.data
		})
	},
	SearchQuitInfo(params) {
		return axios.get(`app/kkOrder/refundDetail`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},
	SearchTxt(params) {
		return axios.get(`app/kkOrder/showMsg`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},
}

export default clienteleServer


// WEBPACK FOOTER //
// ./src/api/clientele.js